<ng-container *ngIf="pagination$ | async as pagination">
  <ng-container *ngIf="totalItems$ | async as totalItems">
    <ng-container *tuiLet="totalPages(pagination, totalItems) as numberOfPages">
      <ng-container *ngIf="!(hideOnSinglePage && numberOfPages < 2)">
        <div class="wo-paginator {{cssClass}}">
          <div class="wo-paginator-page wo-paginator__page is-hidden-mobile">
            <div>View</div>
            <tui-select
              class="tw-w-[68px]"
              [ngModel]="pagination.size"
              (ngModelChange)="sizeChanged.emit($event)"
              [tuiTextfieldLabelOutside]="true"
              tuiTextfieldSize="s"
            >
              <ng-template tuiDataList>
                <tui-data-list>
                  <button
                    *ngFor="let item of pages"
                    tuiOption
                    [value]="item"
                  >
                    {{ item }}
                  </button>
                </tui-data-list>
              </ng-template>
            </tui-select>
            <div>rows per page</div>
          </div>
          <div class="wo-paginator__summary is-hidden-mobile" data-e2e="list summary text">
            Showing {{ startIndex(pagination) + 1 }} to {{ endIndex(pagination, totalItems) + 1 }} of {{ totalItems }} entries.
          </div>
          <iss-paginator
            class="wo-paginator__pages"
            [currentPage]="pagination.page"
            [numberOfPages]="numberOfPages"
            (currentPageChange)="pageChanged.emit($event)"
          ></iss-paginator>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-container>
